<template>
  <main-layout>

    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-03"></menubar>
    </div>

    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">{{$t('title.system.owner.title')}}</label>
        <sp-smart-button @click="back" slot="cancel">キャンセル</sp-smart-button>
        <narrow-down v-auth="{auth:'010202'}" @click="createOwner(ownerDetail)" slot="create">{{ $t("button.common.data.create") }}</narrow-down>
      </head-title>
    </el-row>

    <div slot="body">

      <!-- subtitle -->
      <div class="main-title">
        {{$t("title.system.owner.create2")}}
      </div>

      <!--  ヘッダー行の開始  -->
      <el-row class="must-top m-bottom-5">
        <span style="color: #e65245">* </span>{{ $t("label.common.must") }}
      </el-row>
      <!--  フォーム開始  -->

      <el-row>
        <div>
          <el-form
            label-position="left"
            :rules="rules"
            :model="ownerDetail"
            class="submit-form"
            label-width="204px"
            ref="ownerDetail"
            >
            <el-row class="owner-create-form">
              <div class="width-204 float-left">
                <label class="lb1">{{"基本情報"}}</label>
              </div>
              <div class="width-528 float-left">
                <el-row class="height-44">
                  <!--  オーナーID  -->
                  <el-form-item
                    :label="$t('label.system.owner.create.ownerExId')"
                    prop="ownerExId"
                    size="small"
                    class="asterisk line-height-44">
                    <el-input
                      class="lang-width-input show-word-limt-input-iot"
                      size="small"
                      placeholder="例：OW0000001"
                      v-model="ownerDetail.ownerExId"
                      maxlength="20"
                      show-word-limit
                    />
                  </el-form-item>
                </el-row>

                <el-row class="height-44">
                  <!--  オーナー名  -->
                  <el-form-item
                    :label="$t('label.system.owner.create.ownerName')"
                    prop="ownerName"
                    size="small"
                    class="asterisk line-height-44"
                  >
                    <el-input
                      class="lang-width-input show-word-limt-input-iot"
                      size="small"
                      placeholder="例：丸一不動産商事"
                      v-model="ownerDetail.ownerName"
                      maxlength="50"
                      show-word-limit
                    />
                  </el-form-item>
                </el-row>

              </div>
            </el-row>

            <hr class="delimiter-60" />

            <el-row class="owner-create-form">
              <div class="width-204 float-left">
                <label class="lb1">{{"基本ポイント設定"}}</label>
              </div>
              <div class="width-528 float-left">
                <el-row class="pointRate height-44">
                  <!--  締め日  -->
                  <el-form-item
                    :label="$t('label.system.owner.create.pointSime')"
                    prop="closeDate"
                    size="small"
                    class="asterisk line-height-44"
                  >
                    <el-row class="form-group">
                      <div class="width-120">
                        <el-select
                          v-model="ownerDetail.closeDate"
                          size="small"
                          placeholder=""
                        >
                          <el-option
                            v-for="item in closeDateList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </div>
                    </el-row>
                  </el-form-item>
                </el-row>

                <el-row class="pointRate height-44">
                  <!--  デフォルト有効期限  -->
                  <el-form-item
                    :label="$t('label.system.owner.create.expirationMonth')"
                    prop="closeDate"
                    size="small"
                    class="asterisk line-height-44"
                  >
                    <el-row class="form-group">
                      <div class="width-120">
                        <el-select
                          v-model="ownerDetail.expirationMonth"
                          size="small"
                          placeholder=""
                        >
                          <el-option
                            v-for="item in expirationMonthList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </div>
                      <div class="m-left-2">
                        <span class="c-ivory01">
                          {{ $t('label.system.owner.create.month') }}
                        </span>
                      </div>
                    </el-row>
                  </el-form-item>
                </el-row>

                <el-row class="pointRate height-44">
                  <!--  ポイント手数料率  -->
                  <el-form-item
                    :label="$t('label.system.owner.create.pointFeeRate')"
                    prop="pointFeeRate"
                    size="small"
                    class="asterisk line-height-44"
                  >
                    <el-row class="form-group">
                      <div class="width-120">
                        <el-input
                          size="small"
                          maxlength="6"
                          placeholder="例：0.5"
                          v-model="ownerDetail.pointFeeRate">
                        </el-input>
                      </div>
                      <div class="m-left-2">
                        <span class="c-ivory01">%</span>
                      </div>
                    </el-row>
                  </el-form-item>
                </el-row>

                <el-row class="pointRate height-44 margin-bottom-0">
                  <!--  ポイント変換率  -->
                  <el-form-item
                    :label="$t('label.system.owner.create.pointExcRate')"
                    prop="pointExcRate"
                    size="small"
                    class="asterisk line-height-44"
                  >
                    <el-row class="form-group">
                      <div class="width-120">
                        <el-input
                          size="small"
                          maxlength="6"
                          placeholder="例：0.5"
                          v-model="ownerDetail.pointExcRate">
                        </el-input>
                      </div>
                      <div class="m-left-2">
                        <span class="c-ivory01">%</span>
                      </div>
                    </el-row>
                  </el-form-item>
                </el-row>

              </div>
            </el-row>

            <hr class="delimiter-60" />

            <!--  責任者情報部分 開始  -->
              <el-row>
                <div class="width-204 float-left">
                  <label class="lb1">{{"責任者情報"}}</label>
                </div>
                <div class="width-528 float-left">
                  <el-row class="height-44 owner-create-form">
                    <!--  氏名  -->
                    <el-form-item
                      :label="$t('label.system.owner.create.respUserName')"
                      size="small"
                      prop="resUserName"
                      class="owners-search-respUserName line-height-44"
                      hide-required-asterisk="ture">
                      <div class="width-120 float-left">
                        <el-input
                          maxlength="20"
                          placeholder="例：佐藤"
                          v-model="ownerDetail.resUserName"
                          class="text-right show-word-limt-input-iot-small"
                          show-word-limit
                        />
                      </div>
                    </el-form-item>
                  </el-row>

                  <el-row class="height-44 owner-create-form">
                    <!--  電話番号  -->
                    <el-form-item
                      :label="$t('label.system.owner.create.respUserTel')"
                      size="small"
                      class="line-height-44"
                      prop="respUserTel">
                      <el-input
                        size="small"
                        maxlength="20"
                        placeholder="例：01234567890123456789"
                        class="show-word-limt-input-iot"
                        show-word-limit
                        v-model="ownerDetail.respUserTel"
                      />
                    </el-form-item>
                  </el-row>

                  <el-row class="height-44 owner-create-form" >
                    <!--  メールアドレス  -->
                    <el-form-item
                      :label="$t('label.system.owner.create.respUserEmail')"
                      size="small"
                      class="line-height-44"
                      prop="respUserEmail">
                      <el-input
                        maxlength="319"
                        size="small"
                        placeholder="例：user1@test.jp"
                        v-model="ownerDetail.respUserEmail"
                      />
                    </el-form-item>
                  </el-row>

                  <el-row class="height-44 owner-create-form margin-bottom-0">
                    <!--  契約番号  -->
                    <el-form-item
                      :label="$t('label.system.owner.create.respUserContractNo')"
                      size="small"
                      class="line-height-44"
                      prop="respUserContractNo">
                      <el-input
                        maxlength="20"
                        size="small"
                        placeholder="例：N0000001"
                        class="show-word-limt-input-iot"
                        show-word-limit
                        v-model="ownerDetail.respUserContractNo"
                      />
                    </el-form-item>
                  </el-row>
                </div>
              </el-row>
              <!--  責任者情報部分 終わり  -->

              <hr class="delimiter-60" />

              <!--  本社情報 開始  -->
              <el-row>
                <div class="width-204 float-left">
                  <label class="lb1">{{$t("label.system.owner.create.headquartersInformation")}}</label>
                </div>
                <div class="width-528 float-left">

                  <el-row class="height-44 owner-create-form">
                    <!--  住所  -->
                    <el-form-item
                      size="small"
                      class="line-height-44"
                      :label="$t('label.system.owner.create.companyAddress')"
                      prop="companyAddress">
                      <el-input
                        maxlength="200"
                        size="small"
                        placeholder="例：東京都港区赤坂５－７５２"
                        class="show-word-limt-input-iot"
                        show-word-limit
                        v-model="ownerDetail.companyAddress"
                      />
                    </el-form-item>
                  </el-row>

                  <el-row class="height-44 owner-create-form margin-bottom-0">
                    <!--  電話番号  -->
                    <el-form-item
                      size="small"
                      class="line-height-44"
                      :label="$t('label.system.owner.create.companyTel')"
                      prop="companyTel">
                      <el-input
                        maxlength="20"
                        size="small"
                        class="show-word-limt-input-iot"
                        show-word-limit
                        placeholder="例：01234567890123456789"
                        v-model="ownerDetail.companyTel"
                      />
                    </el-form-item>
                  </el-row>
                </div>
              </el-row>

              <hr class="delimiter-60" />

              <!--  本社情報 終わり  -->
              <el-row>
                <div class="width-204 float-left">
                  <label class="lb1">{{"サービス開通/停止"}}</label>
                </div>
                <div class="float-left">
                  <el-row>
                    <!--  サービス開通日時  -->
                    <el-row type="flex" align="middle" class="m-bottom-5">
                      <div class="float-left">
                        <el-form-item
                          class="asterisk"
                          prop="serviceStartDt"
                          label="サービス開通日時"
                          :rules="startDate">
                          <div class="form-group">
                            <el-date-picker
                              class="date-picker-background-color"
                              value-format="yyyy/MM/dd"
                              type="date"
                              :clearable="false"
                              @blur="this.$reset"
                              @change="startTimeSelect"
                              :format="'yyyy年M月d日'+' '+'('+ [weekDays]+')'"
                              v-model="ownerDetail.serviceStartDt"
                            />
                            <el-select
                              class="m-left-2 date-time-select"
                              placeholder=""
                              v-model="ownerDetail.startTime">
                                <el-option
                                  v-for="item in timeList"
                                  :value="item"
                                  :key="item"
                                  :label="item">
                                </el-option>
                                <!--  -->
                            </el-select>
                          </div>

                        </el-form-item>
                      </div>
                    </el-row>
                    <!--  サービス停止日時  -->
                    <el-row type="flex" align="middle">
                      <div class="float-left">
                        <el-form-item
                          prop="serviceEndDt"
                          label="サービス停止日時"
                          :rules="endDate">
                          <div class="form-group">
                            <el-date-picker
                              class="date-picker-background-color"
                              type="date"
                              :clearable="false"
                              @blur="this.$reset"
                              @change="endTimeSelect"
                              value-format="yyyy/MM/dd"
                              :format="'yyyy年M月d日'+' '+'('+ [weekDay]+')'"
                              v-model="ownerDetail.serviceEndDt">
                            </el-date-picker>
                            <el-select
                              class="date-time-select m-left-2"
                              placeholder=""
                              v-model="ownerDetail.endTime">
                                <el-option
                                  v-for="item in timeList"
                                  :value="item"
                                  :key="item"
                                  :label="item">
                                </el-option>
                            </el-select>
                            <div class="float-left m-left-2">
                              <select-btn @click="clearEndDate" class="clear-width">
                                クリア
                              </select-btn>
                            </div>
                          </div>
                        </el-form-item>
                      </div>
                    </el-row>
                  </el-row>
                </div>
              </el-row>

              <narrow-down v-auth="{auth:'010202'}"
                class="m-top-60 m-left-408"
                @click="createOwner(ownerDetail)">
                {{ $t("button.common.data.create") }}
              </narrow-down>

            </el-form>
          </div>
        </el-row>
        <el-dialog-prompt
          :centerDialogVisibleParam.sync="errorMsgShow"
          :msgParam="msgError">
        </el-dialog-prompt>

        <el-dialog-prompt
          :centerDialogVisibleParam.sync="errorMsgsShow"
          :msgParam="msgsError">
        </el-dialog-prompt>

        <el-dialog-prompt
          :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
          :msgParam="msgParam"
          @on-isPassParam="isPassParam">
        </el-dialog-prompt>

        <loading-dialog :dialogVisible="showLoading" />

      <!--  表单 終わり  -->
    </div>
  </main-layout>
</template>

<script>
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import OwnerCreateRuleFactory from "@/rules/rule-owner-create";
import NewDesignLayout from "@/layout/NewDesignLayout";
import SystemManageApi from "@/api/SystemManageApi";
import Menubar from "@/components/leftmenu/DashBoard"
import headTitle from "@/components/common/head/head";
import selectBtn from "@/components/common/generalButton/Select"
import SpSmartButton from "@/components/common/sp-smart-button";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import elDialogPrompt from "@/components/common/el-dialog-prompt"

// 引入按钮组件
const weeksDay = ['日','月','火','水','木','金','土']
export default {
  name: "OwnerCreate",
  components: {
    MainLayout: NewDesignLayout,
    headTitle,
    LoadingDialog: LoadingDialog,
    Menubar,
    selectBtn,
    SpSmartButton,
    narrowDown,
    elDialogPrompt
  },
  data() {
    var validateStartDate = (rule,value,callback) => {
      this.$checkServceStartDate(this.ownerDetail.serviceStartDt, this.ownerDetail.startTime,callback);
      this.$CheckFromToDate(this.ownerDetail.serviceStartDt, this.ownerDetail.serviceEndDt,
                          this.ownerDetail.startTime, this.ownerDetail.endTime,
                          this.$t('label.system.messageSearch.startDateStart'),
                          this.$t('label.system.messageSearch.startDateEnd'),
                          callback
                          );
    }
    var validateEndDate = (rule,value,callback) =>{
      this.$refs["ownerDetail"].validateField("serviceStartDt");
      this.$checkServceEndDate(this.ownerDetail.serviceEndDt, this.ownerDetail.endTime,callback);
      callback()
    }
    return {
      msgParam: this.$t("message.common.isSave",{
        field: "オーナー"
      }),
      createSuccess: this.$t("message.common.createSuccess",{
        field: "オーナー"
      }),
      checkEndDateFlag : true,
      msgError: "ポイント手数料率を100を超えることはできません。",
      msgsError: "ポイント変換率を100を超えることはできません。",
      errorMsgShow: false,
      errorMsgsShow: false,
      centerDialogVisibleIsShow: false,
      ownerId: null,
      timeList: [],
      closeDateList: [],
      expirationMonthList: [],
      ownerDetail: {
        ownerExId: null,
        ownerName: null,
        pointFeeRate: '',
        pointExcRate: '',
        closeDate: 31,
        expirationMonth: 6,
        resUserName: null,
        respUserTel: null,
        respUserEmail: null,
        respUserContractNo: null,
        companyAddress: null,
        companyTel: null,
        serviceEndDt:null,
        serviceStartDt:null,
        lastUserName:null,
        firstUserName:null,
        postalCode:null,
        startTime:null,
        endTime:null
      },
      rules: OwnerCreateRuleFactory.createRules(this),
      showLoading: false,
      weekDays:null,
      weekDay:null,
      startDate:
      [
        {
          required: true,
          trigger: 'change',
          message: this.$t('message.common.validation.required', {
            field: this.$t('label.system.owner.create.serviceStartDt')
          })
        },
        { validator: validateStartDate, trigger: 'change' },
      ],
      endDate:
      [
        { validator: validateEndDate, trigger: 'change' },
      ]
    };
  },
  watch: {
    "ownerDetail.serviceStartDt"(val) {
      if(val == null || val == "") {
        this.ownerDetail.startTime = null
      }
    },
    "ownerDetail.serviceEndDt"(val) {
      if(val == null || val == "") {
        this.ownerDetail.endTime = null
      }
    }

  },
  methods: {
    clearEndDate () {
      this.ownerDetail.serviceEndDt = null
      this.ownerDetail.endTime = null
    },
    //クリックしてイベントを保存
    createOwner() {
      // var rule = this.endDate[0]
      // this.endDate.pop(0)
      this.$refs["ownerDetail"].validate((valid) => {
        if (valid) {
          this.centerDialogVisibleIsShow = true
        }
      });
      // this.endDate.push(rule)
    },
    timeBack(val){
      if( this.ownerDetail.serviceStartDt == null ) {
        this.ownerDetail.serviceStartDt = new Date()
        setTimeout(() => {
          this.ownerDetail.serviceStartDt = null
        },0)
      }else {
        this.ownerDetail.serviceStartDt = val
      }
    },
    isPassParam(param){
      if(param){
        this.doneCreateOwner()
      }
    },

    doneCreateOwner() {
      this.centerDialogVisibleIsShow = false;
      this.showLoading = true;
      let pointFeeRate = null
      let pointExchangeRate = null
      if(this.ownerDetail.pointFeeRate) {
         pointFeeRate = Number(this.ownerDetail.pointFeeRate)/100
      }
      if(this.ownerDetail.pointExcRate) {
         pointExchangeRate = Number(this.ownerDetail.pointExcRate)/100
      }
      let serviceStartDate = this.ownerDetail.serviceStartDt + ' ' +this.ownerDetail.startTime
      let serviceEndDate = null
      if(this.ownerDetail.serviceEndDt && this.ownerDetail.endTime) {
        serviceEndDate = this.ownerDetail.serviceEndDt + ' ' +this.ownerDetail.endTime
      }
      SystemManageApi.createOwner({
        ownerExId: this.ownerDetail.ownerExId,
        ownerName: this.ownerDetail.ownerName,
        pointFeeRate: Number(pointFeeRate),
        pointExchangeRate: Number(pointExchangeRate),
        closeDate: this.ownerDetail.closeDate,
        expirationMonth: this.ownerDetail.expirationMonth,
        resUserName: this.ownerDetail.resUserName,
        resUserTelNo: this.ownerDetail.respUserTel,
        resUserEmail: this.ownerDetail.respUserEmail,
        resContractNo: this.ownerDetail.respUserContractNo,
        companyAddress: this.ownerDetail.companyAddress,
        companyTelNo: this.ownerDetail.companyTel,
        serviceStartDateTime: serviceStartDate,
        serviceEndDateTime: serviceEndDate,
      })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this, "OwnerCreate")) {
            return;
          }
          if ("Success" != data.statusCode) {
            if (
              data.message != "" ||
              data.message != null ||
              data.message != undefined
            ) {
              this.$messageIotError(data.message);
            }
            return
          }
          this.ownerId = data.body.ownerId;
          this.$router.push({
            name: "system-owner-detail",
            params: {
              ownerId: this.ownerId,
            },
          });
          this.$messageIotSuccess(this.createSuccess);
        }).finally(()=>{
          this.showLoading = false
        })
    },
    back() {
      this.$router.push({
        name: "system-owner-search",
      });
    },
    getChoseStartDate(val){
      this.ownerDetail.serviceStartDt = val;
    },
    getChoseEndDate(val){
      this.ownerDetail.serviceEndDt = val;
    },
    startTimeSelect(val){
      if(val){
        this.weekDays= weeksDay[new Date(val).getDay()]
      }
      if(!this.ownerDetail.startTime) {
        this.ownerDetail.startTime = "00:00"
      }
    },

    timeSlot () {
        let step = 15
        var date = new Date("2021-01-14 00:00:00")
        let timeArr = [];
        var slotNum = 24*60/step
        for (var f = 0; f < slotNum; f++) {
            var time = new Date(Number(date.getTime()) + Number(step*60*1000*f))
            var hour = '', sec = '';
            time.getHours() < 10 ? hour = '0' + time.getHours() : hour = time.getHours()
            time.getMinutes() < 10 ? sec = '0' + time.getMinutes() : sec = time.getMinutes()
            timeArr.push(hour + ':' + sec)
        }
        return timeArr
    },

    endTimeSelect(val){
      if(val){
        this.weekDay = weeksDay[new Date(val).getDay()]
      }
      if(!this.ownerDetail.endTime) {
        this.ownerDetail.endTime = "00:00"
      }
    },
  },
  created() {
    for (let i = 0; i < 31; i++) {
      this.closeDateList.push({
        label: (i + 1) + '日',
        value: i + 1
      })
    }
    for (let i = 0; i < 6; i++) {
      this.expirationMonthList.push({
        label: i + 1,
        value: i + 1
      })
    }
    this.timeList=this.timeSlot()
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/owners/search",
        title: "label.router.owner",
      },
      {
        path: "",
        title: "label.router.ownerCreate",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
    this.$authCheck("010202")
  }
};
</script>

<style lang="scss" scoped>
::v-deep .cancel-width{
  .my-button{
    width: 152px;
    height: 32px;
  }
}
.must-top{
  color:#525250;
}

.width-204{
  width: 204px;
  height: 27px;
  margin-top: 4px;
}

.width-528{
  width: 528px;
}
.owner-create-form::v-deep {
  .el-input__inner {
    width: 324px;
    height: 44px !important;
    padding:0px 16px 0px 16px;
  }
}
.pointRate::v-deep {
  .el-input__inner {
    width: 120px;
    height: 44px !important;
    padding:0px 16px 0px 16px;
  }
}
.owners-search-respUserName::v-deep {
  .el-input__inner {
    width: 120px;
    height: 44px !important;
    padding:0px 16px 0px 16px;
  }
}
::v-deep .user-search-postalCode{
  .el-input__inner {
  width: 120px;
  height: 44px !important;
  border-radius: 8px !important;
  background: #F2F2ED;
  border: none;
  padding:0px 0px 0px 16px;
  box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
    4px 5px 5px #E6E6E1 inset, 4px 5px 5px #E6E6E1 inset;
  }
}
::v-deep .asterisk {
  .el-form-item__label::after{
    content: "*";
    color: #F56C6C;
    margin-right: 4px;
  }
}
::v-deep .el-form-item__label::before{
  display: none;
}
.width-120{
  width: 120px;
}
.height-44{
  height: 44px;
  margin-bottom: 40px;
}
.float-left {
  float: left;
}
.hr {
  height: 1px;
  //width: 800px;
  background-color: #D1D1CD;
}
::v-deep.el-form-item__label {
    font-size: 16px !important;
}
.pick_date_box {
  width: 188px !important;
  height: 40px !important;
  border: none !important;
  background-color: #F7F7F2;
  ::v-deep .el-icon-date:before {
    display: none;
  }
  ::v-deep .el-icon-date:after {
    display: none;
  }
  ::v-deep.el-input__inner {
    width: 188px !important;
    height: 40px !important;
    font-size: 13px;
    padding-left: 20px;
    border: none;
    border-radius: 4px !important;
    background-color: #F2F2ED;
    box-shadow:
    -2px -2px 5px #ffffff ,4px 5px 5px #E6E6E1 ;
  }
}
.img-size {
  position: relative;
  margin-left: -30px;
  margin-bottom: -5px;
  -webkit-pointer-events: none;
  -moz-pointer-events: none;
  -ms-pointer-events: none;
  -o-pointer-events: none;
  pointer-events: none;
}
::v-deep .time-select {
  width: 120px;
  font-size: 15px;
  height: 40px;
  border-radius: 8px;
  box-shadow: -2px -2px 4px #fff,
              4px 4px 4px #E6E6E1;
    .el-input__inner {
    height: 40px;
    border-radius: 10px;
    background-color: #F2F2ED;
    border: 0;
    color: #525250;
  }
  .el-input__suffix {
    top: 0px;
  }
  .el-input__icon {
    line-height: 25px !important;
  }
}
::v-deep .el-form-item__error {
  width: 500px;
}
::v-deep .date-picker-background-color {
  .el-input__inner {
    background-color: #F2F2ED !important;
  }
}
::v-deep .date-time-select {
  .el-input__inner {
    width: 120px !important;
  }
}

.margin-bottom-0 {
  margin-bottom: 0px;
}

.line-height-44::v-deep {
  .el-form-item__label {
    line-height: 44px !important;
  }
}

.m-left-408 {
  margin-left: 408px;
}
</style>
